import { createSlice } from '@reduxjs/toolkit';

export const submission = createSlice({
  name: 'SUBMISSION',
  initialState: {}, // this comes from preloadedState in the store

  reducers: {
    setSubmission(state, action) {
      const { payload } = action;
      const { id, token } = payload;

      state.id = id;
      state.token = token;
      state.error.message = null; // clear error message
      state.ancestorSid = state.ancestorSid ? state.ancestorSid : id;
    },

    setSubmissionErrorMessage(state, action) {
      const { payload } = action;
      const { errorMessage } = payload;
      state.errorMessage = errorMessage;
    },

    setResubmit(state, action) {
      const { payload } = action;
      const { shouldResubmit, replaceAncestorSid } = payload;
      if (replaceAncestorSid) {
        state.ancestorSid = null;
      }
      state.shouldResubmit = shouldResubmit;
    },

    setSubmissionStatus(state, action) {
      const { payload } = action;
      const { submissionStatus } = payload;
      state.submissionStatus = submissionStatus;
    },

    setFirstSubmissionAttemptTimestamp(state, action) {
      const { firstSubmissionAttemptTimestamp } = action.payload;
      state.firstSubmissionAttemptTimestamp = firstSubmissionAttemptTimestamp;
    },

    setRetrySubmissionTimestamp(state, action) {
      const { submissionRetryTimestamp } = action.payload;
      state.submissionRetryTimestamp = submissionRetryTimestamp;
    },

    setSelectAndConnectBrands(state, action) {
      const { selectAndConnectBrands } = action.payload;
      state.selectAndConnectBrands = selectAndConnectBrands;
    },

    updateSelectAndConnectBrandSubmissionStatus(state, action) {
      const { brandId, submissionStatus } = action.payload;
      state.selectAndConnectBrands[brandId].submissionStatus = submissionStatus;
    },

    setPartialSubmissionStatus(state, action) {
      const { partialSubmissionStatus } = action.payload;
      state.partialSubmissionStatus = partialSubmissionStatus;
    },

    setBsaSubmissionStatus(state, action) {
      const { bsaSubmissionStatus } = action.payload;
      state.bsaSubmissionStatus = bsaSubmissionStatus;
    },

    /**
     * The token is the proof that this session created that BSA submission.
     * The converting "Get Quotes" request sends it back so the gateway will
     * honour the supersede-in-place hint (GOLD-2422).
     */
    setBsaSubmissionId(state, action) {
      const { bsaSubmissionId, bsaSubmissionToken } = action.payload;
      state.bsaSubmissionId = bsaSubmissionId;
      state.bsaSubmissionToken = bsaSubmissionToken;
    },

    setLatestPartialSubmissionQuestions(state, action) {
      const { latestPartialSubmissionQuestions } = action.payload;
      state.latestPartialSubmissionQuestions = latestPartialSubmissionQuestions;
    },

    /**
     * This reducer should be used to react to a customer action which should block submissions. When there are existing submission blocks, the customer will be unable to submit and will be shown a message when passing the page with the submission block on it.
     */
    setSubmissionBlock(state, action) {
      const { type, page, identifier, isBlockingSubmission, message } =
        action.payload;

      if (isBlockingSubmission) {
        return {
          ...state,
          submissionBlocks: [
            ...state.submissionBlocks,
            { type, identifier, message, page },
          ],
        };
      }
      return {
        ...state,
        submissionBlocks: state.submissionBlocks.filter(
          (block) =>
            !(
              block.identifier === identifier &&
              block.type === type &&
              block.message === message &&
              block.page === page
            )
        ),
      };
    },
  },
});

const { actions, reducer } = submission;

export const {
  setSubmission,
  setSubmissionErrorMessage,
  setResubmit,
  setSubmissionStatus,
  setRetrySubmissionTimestamp,
  setFirstSubmissionAttemptTimestamp,
  setSelectAndConnectBrands,
  updateSelectAndConnectBrandSubmissionStatus,
  setPartialSubmissionStatus,
  setBsaSubmissionStatus,
  setBsaSubmissionId,
  setLatestPartialSubmissionQuestions,
  setSubmissionBlock,
} = actions;

export default reducer;
